import React from "react";
import { ButtonGroup, ModalContent, ModalHeader } from "./Modals.styled";
import { useTranslation } from "react-i18next";
import { ActionButton } from "@talentbait/shared-components";

export const DeleteConfirm = ({ header, confirm, cancel }) => {
  const { t } = useTranslation();

  return (
    <ModalContent>
      <ModalHeader>{header || t("Are you sure you want to delete this?")}</ModalHeader>
      <ButtonGroup>
        <ActionButton onClick={confirm} text={t("Confirm")} />
        <ActionButton variant="secondary" size="small" onClick={cancel} text={t("Cancel")} />
      </ButtonGroup>
    </ModalContent>
  );
};
